import React, {FC} from "react";
import moment from "moment";
import ApolloWrapper from "./ApolloWrapper";
import TimezoneBootstrap from "./TimezoneBootstrap";
import CurrencyBootstrap from "./CurrencyBootstrap";
import AppRoutes from "./AppRoutes";
import CookieBanner from "../CookieBanner/CookieBanner";
import AnnouncementBanner from "../AnnouncementBanner/AnnouncementBanner";
import MollieReconnectBanner from "../MollieReconnectBanner/MollieReconnectBanner";

type AppProps = {};

const App: FC<AppProps> = () => {
    moment.locale("de");

    return (
        <ApolloWrapper>
            <TimezoneBootstrap>
                <CurrencyBootstrap>
                    <CookieBanner />
                    <AnnouncementBanner />
                    <MollieReconnectBanner />
                    <AppRoutes />
                </CurrencyBootstrap>
            </TimezoneBootstrap>
        </ApolloWrapper>
    );
};

export default App;
